import { useQuery } from '@apollo/client'
import { useState } from 'react'

import { SelectOption } from 'components/Select'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { fromDTO } from './api/mapper'
import { GET_DOMAINS_FOR_PAGE_BASIC_ATTRIBUTES } from './api/query'
import { DomainSliceDTO } from './api/types'
import { DomainSlice, UseGetDomainsForSelect } from './types'

export const useGetDomainsForSelect = (): UseGetDomainsForSelect => {
  const { workspaceId } = useWorkspaceParam()
  const [domains, setDomains] = useState<SelectOption<DomainSlice>[]>([])

  useQuery(GET_DOMAINS_FOR_PAGE_BASIC_ATTRIBUTES, {
    onCompleted: ({ domains: { nodes: domains } }): void => {
      if (domains && domains.length > 0) {
        setDomains(
          domains.map((domain: DomainSliceDTO): SelectOption<DomainSlice> => fromDTO(domain)),
        )
      }
    },
    variables: { workspaceId },
  })

  return { domains }
}
